import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

/**
 * Dieser Service stellt den Suchstring im Scuhschlitz des Portals global zur Verfügung.
 */
@Injectable()
export class SearchQueryService {
    private searchQuery = new ReplaySubject<string>(1);

    /** Nur für das Portal: Die eingegebene Search-Query hat sich geändert. */
    searchQueryChanged(query: string) {
        this.searchQuery.next(query);
    }

    /** Liefert ein Observable für die aktuelle searchQuery. Debouncing und Deduplizierung sind bereits enthalten. */
    getSearchQuery(): Observable<string> {
        return this.searchQuery.asObservable()
            .pipe(
                debounceTime(250),
                distinctUntilChanged());
    }
}
